export default [
  'paymentConfigType',
  'index',
  'method',
  // 'paymentTerm',
  'days',
  'offset',
  'paymentWorkingDay',
];
